import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=7fa5f3d2&"
import script from "./Collapse.js?vue&type=script&lang=js&"
export * from "./Collapse.js?vue&type=script&lang=js&"
import style0 from "./Collapse.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports